import React from "react";
import DefaultLayout from "../Layouts/DefaultLayout";
import StoreList from "../Components/Layout/StoreList";

const Stores = () => {
    return (
        <DefaultLayout className="animate-fade-in">
            <StoreList />
        </DefaultLayout>
    );
};

export default Stores;